import { z } from 'zod';
import { NotificationFilter } from './notification.js';
import { NotificationPreferencePatch } from './preferences.js';
export const ListNotificationsQuery = z.object({
    filter: NotificationFilter.default('all'),
    limit: z.number().int().min(1).max(100).default(30),
    offset: z.number().int().min(0).default(0),
});
export const PatchNotificationPreferencesRequest = z.object({
    preferences: z.array(NotificationPreferencePatch).min(1).max(200),
});
//# sourceMappingURL=requests.js.map